import React from "react";
import ResetPasswordForm from "../../components/Authentication/ResetPasswordForm";

const ResetPassword = () => <ResetPasswordForm />;

export default ResetPassword;
